import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';

import ErrorContact from 'rise-ui/components/error-contact.gjs';
import ErrorPage from 'rise-ui/components/error-page.gjs';
import eq from 'rise-ui/helpers/eq.js';
import string from 'rise-ui/helpers/string.js';
import titleCase from 'rise-ui/helpers/title-case.js';

export default RouteTemplate(class CatalogRecordItemErrorTemplate extends Component {
  <template>
    <ErrorPage class="qa-error-item-not-found" as | error |>
      {{#if (eq @model.name "InvalidArgumentsException")}}
        <error.title>Invalid URL</error.title>
        <error.subtitle>{{titleCase (string "catalog-item")}} does not belong to this Catalog Record.</error.subtitle>
      {{else}}
        <error.title>{{titleCase (string "catalog-item")}} Not Found</error.title>
        <error.subtitle>
          We're sorry, but that {{string "catalog-item"}} could not be found.
          <strong>
            Try returning to the <LinksTo @route="catalog.record">catalog record</LinksTo>
            or searching the <LinksTo @route="catalog">catalog</LinksTo>.
          </strong>
        </error.subtitle>
      {{/if}}
      <error.content><ErrorContact/></error.content>
    </ErrorPage>
  </template>
});
